import fog from '../../common/fog';
import { Color } from 'three';
import { preprocess } from '@artica/assets';

preprocess('tilescape', function preprocessTilescape(gltf) {
  const { materials } = gltf;

  fog(materials.Terrain_PBR, {
    fogNearColor: new Color(0.27, 0.26, 0.29),
    fogHorizonColor: new Color(0.27, 0.26, 0.29),
    fogDensity: 0.00025,
    fogNoiseSpeed: 100,
    fogNoiseFreq: 0.092,
    fogNoiseImpact: 0,
    fogCeiling: -73.0,
    fogFloor: -87.5,
  });

  return gltf;
});